// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ion-button {\n  min-width: 230px;\n}", "",{"version":3,"sources":["webpack://./src/app/pages/login/buy-ticket-button/buy-ticket-button.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF","sourcesContent":["ion-button {\r\n  min-width: 230px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
